import React from "react";
import cx from "classnames";
import styled from "styled-components";
import { Copy } from "components/components/atoms";
import useBreakpoint from "utils/hooks/useBreakpoint";

const SectionHeading = styled.h2`
  letter-spacing: -0.01em;
`;

const StyledCopy = styled(Copy)`
  overflow-wrap: break-word;
  word-break: normal;
  max-height: 180px;
  overflow-y: auto;
`;

const TimelineTextSlide = ({
  index,
  labelName = "",
  title = "",
  text = "",
}) => {
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  return (
    <div
      data-aos="fade-zoom-in"
      data-aos-delay="350"
      data-aos-offset="0"
      className={cx("w-full flex flex-col mx-4 self-center", {})}
    >
      <SectionHeading className="pt-2 font-bold font-trade-gothic-20 text-2xl md:text-4xl mb-3 text-mattamy-blue leading-tiny break-words mr-4">
        {title}
      </SectionHeading>

      <StyledCopy
        color="blue"
        className="pb-10 md:pb-4 leading-relaxed text-sm md:text-normal break-words mr-4"
      >
        {text}
      </StyledCopy>
    </div>
  );
};

export default TimelineTextSlide;
